<script>
	import Button from "$lib/components/Button.svelte";
	// import Image from "$lib/components/Image.svelte";
	import TransitionBackground from "$lib/components/TransitionBackground.svelte";
    import leftImg from "$lib/images/home/mainScreenLeft.png";
    import rightImg from "$lib/images/home/mainScreenRight.png";
    import leftImgWebp from "$lib/images/home/webp/mainScreenLeft.webp";
    import rightImgWebp from "$lib/images/home/webp/mainScreenRight.webp";
	import { buyVisible } from "../../routes/states";
</script>

<section class="mainScreen">
    <div class="mainScreen__wrap">
        <!-- <Image src={leftImg} alt="PROBAITS спрей для ловли рыбы"/> -->
        <picture>
            <source srcset={leftImgWebp} type="image/webp">
            <img class="mainScreen__left" src={leftImg} alt="PROBAITS спрей для ловли рыбы" draggable="false" aria-hidden="false" decoding="async">
        </picture>
        <!-- <Image src={rightImg} alt="PROBAITS бойлы для ловли рыбы"/> -->
        <picture>
            <source srcset={rightImgWebp} type="image/webp">
            <img class="mainScreen__right" src={rightImg} alt="PROBAITS бойлы для ловли рыбы" draggable="false" aria-hidden="false" decoding="async"> 
        </picture>
        <div class="text">
            <div class="container">
                <h1>PROBAITS — приманка для рыбы</h1>
                <p>
                    Натуральные добавки для ловли рыб, которые используются для усиления пищевого сигнала и стимуляции аппетита.
                </p> 
                <Button styleType="fill" tag="button" on:click={()=>{buyVisible.set(true)}}>
                    Купить
                </Button>
            </div>
        </div>
    </div>
    <div class="mainScreen__transition">
        <TransitionBackground />
    </div>
</section>

<style lang="postcss">
    .mainScreen{
        box-sizing: content-box;
        position: relative;
        background: var(--color-text);
        color: var(--color-bg-0);
        text-align: center;
        display: flex;
        flex-direction: column;
        height: calc(100vh - var(--header-height));
        min-height: 34.1667rem;
        align-items: center;
        margin: * * 5.4rem;
        box-sizing: content-box;
        padding: * * 10vw;

        /* padding: * * 24%; */
    }
    picture{
        & img{
            size: 30vw auto;
            flex: 30vw 0 0;
            max-size: 9.0625rem auto;
        }
        &:nth-child(2) img{
            margin-left: auto;
        }
    }
    .mainScreen__transition{
        position: absolute auto 0 -0.0714rem;
        padding: 9.75rem 0 0;
        max-size: 100% 0; /*20.125rem*/
    }
    .mainScreen__wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .text{
        margin: auto *;
        flex: 100% 0 0;

        & h1{
            max-width: 25.4167rem;
            margin: 1rem auto;
        }
        & p{
            margin: * auto;
            font-size: 1.125rem; 
            max-width: 28.5833rem;
            letter-spacing: -0.0333rem; 
        }
    }
    @media (min-width: 540px){
        .mainScreen{
            padding: * * 10vw;
        }
        .mainScreen__transition{
            height: 5.8rem;
            padding: 25vw * *;
            /* position: absolute auto 0 -10%; */
            /* padding: 26vw 0 0; */
        }
    }
    @media (min-width:680px){
        .mainScreen{
            min-height: 25rem;
        }
        .mainScreen__wrap{
            align-items: center;
            flex-wrap: nowrap;
        }
        .mainScreen__right{
            order: 3;
        }
        .text{
            flex: auto 1 1;
        }
    }
    @media (min-width: 768px){
        .text{
            & p{
                font-size: 1.3333rem; 
            }
        }
        .mainScreen{
            min-height: 34.1667rem;
            box-sizing: border-box;
        }
        .mainScreen__transition{
            position: absolute auto 0 -14%;
            /* padding: 26vw 0 0; */
        }
        picture{
            & img{
                flex: 13rem 1 1;
                max-size: 14.17rem 17.5rem;
            }
            &:first-child img{
                margin: * -2.1rem * auto;
            }
            &:nth-child(2) img{
                margin: * 2.1rem * -2.1rem;
            }
        }
    }
</style>